module.exports = __webpack_public_path__ + "img/funda-logo-white.a837347c.png";